<template>
  <div :class="$setClasses">
    <template v-if="$slots && !$slots.default">
      <el-carousel v-if="photos && photos.length"
                   :autoplay="autoplay"
                   :height="height"
                   :indicator-position="indicatorPosition"
                   :initial-index="initialIndex"
                   trigger="click">
        <el-carousel-item v-for="(image, index) in photos"
                          :key="index">
          <div v-if="!loadedImages[index]"
               :class="$vClass('loading')">
            <loading-icon class="--primary" />
          </div>
          <div v-if="loadedImages[index] && loadedImages[index].error">
            {{ $t('comparator.carousel.error') }}
          </div>
          <img v-else
               :alt="image"
               :class="!loadedImages[index] ? '--display-none' : ''"
               :src="image"
               @error="errorLoad(index)"
               @load="loaded(index)">
        </el-carousel-item>
      </el-carousel>
      <span v-else>{{ notFound ? notFound : $t('comparator.carousel.notFound') }}</span>
    </template>
    <div v-else
         :style="{ width: `${100 * slides}%` }"
         class="carousel--overflow-container"
         ref="container">
      <div :class="$vClass('cards')">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingIcon from '@/utils/components/LoadingIcon.vue';

export default {
  name: 'Carousel',
  nameClassStyle: 'carousel',
  components: {
    LoadingIcon,
  },
  props: {
    index: {
      type: Number,
    },
    slides: {
      type: Number,
    },
    photos: {
      type: Array,
    },
    autoplay: Boolean,
    initialIndex: {
      type: Number,
      default: 0,
    },
    height: {
      type: String,
      default: '350px',
    },
    notFound: String,
    indicatorPosition: String,
  },
  data() {
    return {
      size: 0,
      translated: 0,
      isLoading: true,
      loadedImages: {},
    };
  },
  methods: {
    previous() {
      if (this.index > 0) {
        this.$emit('update:index', this.index - 1);
        this.translated += this.size;
        this.$refs.container.style.transform = `translateX(${this.translated}%)`;
      }
    },
    next() {
      if (this.index + 1 < this.slides) {
        this.$emit('update:index', this.index + 1);
        this.translated -= this.size;
        this.$refs.container.style.transform = `translateX(${this.translated}%)`;
      }
    },
    errorLoad(index) {
      this.$set(this.loadedImages, index, {
        error: true,
      });
    },
    loaded(index) {
      setTimeout(() => {
        this.$set(this.loadedImages, index, true);
        this.isLoading = false;
      }, 300);
    },
  },
  created() {
    this.size = 100 / this.slides;
  },
};
</script>

<style lang="scss" scoped>
  .carousel {
    position: relative;
    overflow: hidden;

    &--overflow-container {
      transition: transform 0.5s ease;
      overflow: hidden;
    }

    &__loading {
      text-align: center;
    }

    &__cards {
      display: flex;
      transition: transform 150ms ease-out;
      transform: translatex(0px);
    }

    &__card {
      margin: 20px 40px;
      width: calc(100% - 80px);

      &__content {
        height: 200px;
        padding: 20px;
        position: relative;

        &__footer {
          position: absolute;
          width: 100%;
          text-align: center;
          bottom: 0;
        }
      }
    }

    .el-carousel__item {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--nxt-color-light-grey);

      img.--display-none {
        display: none;
      }

      img {
        background-color: var(--nxt-color-light-grey);
        width: 100%;
        object-fit: cover;
        margin: auto;
        height: 100%;
        display: block;
      }
    }
  }
</style>
